import { render, staticRenderFns } from "./ApplicationsForm.vue?vue&type=template&id=8797b7f0&scoped=true"
import script from "./ApplicationsForm.vue?vue&type=script&lang=js"
export * from "./ApplicationsForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsForm.vue?vue&type=style&index=0&id=8797b7f0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8797b7f0",
  null
  
)

export default component.exports